/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NodeActionsEntity
 */
export interface NodeActionsEntity {
    /**
     * ノード
     * @type {object}
     * @memberof NodeActionsEntity
     */
    node: object;
    /**
     * ノードで可能なアクション
     * @type {Array<string>}
     * @memberof NodeActionsEntity
     */
    nodeActionTypes: Array<NodeActionsEntityNodeActionTypesEnum>;
}


/**
 * @export
 */
export const NodeActionsEntityNodeActionTypesEnum = {
    Manage: 'manage',
    Read: 'read',
    Start: 'start',
    Submit: 'submit',
    Approve: 'approve',
    Reject: 'reject',
    Revert: 'revert',
    Update: 'update'
} as const;
export type NodeActionsEntityNodeActionTypesEnum = typeof NodeActionsEntityNodeActionTypesEnum[keyof typeof NodeActionsEntityNodeActionTypesEnum];


/**
 * Check if a given object implements the NodeActionsEntity interface.
 */
export function instanceOfNodeActionsEntity(value: object): value is NodeActionsEntity {
    if (!('node' in value) || value['node'] === undefined) return false;
    if (!('nodeActionTypes' in value) || value['nodeActionTypes'] === undefined) return false;
    return true;
}

export function NodeActionsEntityFromJSON(json: any): NodeActionsEntity {
    return NodeActionsEntityFromJSONTyped(json, false);
}

export function NodeActionsEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodeActionsEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'node': json['node'],
        'nodeActionTypes': json['nodeActionTypes'],
    };
}

export function NodeActionsEntityToJSON(json: any): NodeActionsEntity {
    return NodeActionsEntityToJSONTyped(json, false);
}

export function NodeActionsEntityToJSONTyped(value?: NodeActionsEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'node': value['node'],
        'nodeActionTypes': value['nodeActionTypes'],
    };
}

